import createId from 'libs/createId';
import { useState } from 'react';

export default () => {
	const [id] = useState(createId())
	return id;
}